import {
  CLIENT_FUND_ADD_NEW,
  CLIENT_FUND_ADD_NEW_SUCCESS,
  CLIENT_FUND_ADD_NEW_ERROR,
  CLIENT_FUND_DELETE,
  CLIENT_FUND_DELETE_ERROR,
  CLIENT_FUND_DELETE_SUCCESS,
  CLIENT_FUND_EDIT,
  CLIENT_FUND_EDIT_ERROR,
  CLIENT_FUND_EDIT_SUCCESS,
  CLIENT_FUND_GET_BY_ID,
  CLIENT_FUND_GET_BY_ID_ERROR,
  CLIENT_FUND_GET_BY_ID_SUCCESS,
  CLIENT_FUND_GET_LIST,
  CLIENT_FUND_GET_LIST_ERROR,
  CLIENT_FUND_GET_LIST_SUCCESS,
  CLIENT_FUND_ADD_NEW_REQUEST,
  CLIENT_FUND_LOG_LIST,
  CLIENT_FUND_LOG_LIST_SUCCESS,
  CLIENT_FUND_LOG_LIST_ERROR,
  CLIENT_FUND_DELETE_ATTACHMENT,
  CLIENT_FUND_DELETE_ATTACHMENT_SUCCESS,
  CLIENT_FUND_DELETE_ATTACHMENT_ERROR,
  CLIENT_FUND_REPORT,
  CLIENT_FUND_REPORT_SUCCESS,
  CLIENT_FUND_REPORT_ERROR,
} from '../actions';

const initialState = {
  clientFunds: [],
  clientFund: null,
  clientFundLogs: [],
  totalExpense: 0,
  itemCount: 0,
  totalContract: 0,
  totalPage: 0,
  totalApprove: 0,
  totalSubmit: 0,
  totalRejected: 0,
  totalClosed: 0,
  totalDraft: 0,
  totalCompleted: 0,
  totalAll: 0,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CLIENT_FUND_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case CLIENT_FUND_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        clientFund: payload,
      };

    case CLIENT_FUND_LOG_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        clientFundLogs: payload,
      };

    case CLIENT_FUND_LOG_LIST:
    case CLIENT_FUND_GET_LIST:
    case CLIENT_FUND_REPORT:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case CLIENT_FUND_GET_LIST_SUCCESS:
      return {
        ...state,
        clientFunds: payload,
        loading: false,
      };

    case CLIENT_FUND_REPORT_SUCCESS:
      const {
        totalExpense,
        itemCount,
        items,
        totalPage,
        totalContract,
        totalApprove,
        totalSubmit,
        totalRejected,
        totalClosed,
        totalDraft,
        totalCompleted,
        totalAll,
      } = payload;
      return {
        ...state,
        totalExpense,
        itemCount,
        totalPage,
        totalContract,
        totalApprove,
        totalSubmit,
        totalRejected,
        totalClosed,
        totalDraft,
        totalCompleted,
        totalAll,
        clientFunds: items,
        loading: false,
        deleteSuccess: true,
      };
    case CLIENT_FUND_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case CLIENT_FUND_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        clientFund: payload,
        clientFunds: state.clientFunds.concat(payload),
        addSuccess: true,
      };

    case CLIENT_FUND_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case CLIENT_FUND_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case CLIENT_FUND_EDIT_SUCCESS:
      return {
        ...state,
        clientFunds: state.clientFunds.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        clientFund: payload,
        error: null,
        loading: false,
        editSuccess: true,
      };

    case CLIENT_FUND_DELETE_ATTACHMENT:
    case CLIENT_FUND_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };

    case CLIENT_FUND_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        clientFunds: state.clientFunds.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case CLIENT_FUND_DELETE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
      };

    case CLIENT_FUND_DELETE_ATTACHMENT_ERROR:
    case CLIENT_FUND_DELETE_ERROR:
    case CLIENT_FUND_ADD_NEW_ERROR:
    case CLIENT_FUND_EDIT_ERROR:
    case CLIENT_FUND_GET_BY_ID_ERROR:
    case CLIENT_FUND_GET_LIST_ERROR:
    case CLIENT_FUND_LOG_LIST_ERROR:
    case CLIENT_FUND_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
